import React, { useContext, useCallback } from 'react';
import { IDishesContext, DishesContext } from '../../dishesState/dishesContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalSelectCustomer } from 'components/ModalWindows/ModalSelectCustomer';
import { ModalAssignDishToRestaurants } from 'components/ModalWindows/ModalAssignDishToRestaurants';
import { ModalEditModGroupTemplate } from 'components/ModalWindows/ModalEditModGroupTemplate';
import { ModalCopyMenu } from './ModalCopyMenu';

export const ModalWindows: React.FC = () => {
	const {
		refetchData,
		deleteSelectedItem,
		changeTypeOfModalWindow,
		setIDCustomer,
		toggleRememberMyChoice,
		rememberMyChoice,
		typeOfModalWindow,
		IDForAssignRestaurants,
		IDForEditModGroupTemplate,
		fetchedCustomers,
		IDSelectedCustomer,
		isInitializedSelectCustomerModal,
	} = useContext<IDishesContext>(DishesContext);
	const customer = fetchedCustomers.find((customer) => customer.id === IDSelectedCustomer);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithRefetch = useCallback(() => {
		changeTypeOfModalWindow(null);
		refetchData(true);
	}, [changeTypeOfModalWindow]);

	const handleCloseAssignRestaurantsModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingDish');
	}, [changeTypeOfModalWindow]);

	const handleCloseEditModGroupModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingDish');
	}, [changeTypeOfModalWindow]);

	const handleCloseDishHasPortionsError = useCallback(() => {
		changeTypeOfModalWindow('errorDishHasPortions');
	}, [changeTypeOfModalWindow]);

	const handleCloseCopyMenuModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorCopyMenu');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow || !IDSelectedCustomer}>
			{typeOfModalWindow === 'toConfirmDeleteItem' && (
				<ModalToConfirm
					onConsentEvent={deleteSelectedItem}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="deleteDish"
					typeOfInfoIcon="toDelete"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="deleteDishSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorWhileDeletingDish"
				/>
			)}
			{typeOfModalWindow === 'errorUpdatingDish' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorUpdatingDish" />
			)}
			{typeOfModalWindow === 'errorDishHasPortions' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorDishHasPortions" />
			)}
			{typeOfModalWindow === 'errorCopyMenu' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorCopyMenuToRestaurants"
				/>
			)}
			{!IDSelectedCustomer && isInitializedSelectCustomerModal && (
				<ModalSelectCustomer
					setIDCustomer={setIDCustomer}
					toggleRememberMyChoice={toggleRememberMyChoice}
					rememberMyChoice={rememberMyChoice}
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && IDForAssignRestaurants && (
				<ModalAssignDishToRestaurants
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseModalWithRefetch}
					onShowError={handleCloseAssignRestaurantsModalWithError}
					dishId={IDForAssignRestaurants}
				/>
			)}
			{typeOfModalWindow === 'editModGroupTemplate' && IDForEditModGroupTemplate && (
				<ModalEditModGroupTemplate
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseModalWithRefetch}
					onShowError={handleCloseEditModGroupModalWithError}
					onShowProductHasPortionsError={handleCloseDishHasPortionsError}
					dishId={IDForEditModGroupTemplate}
				/>
			)}
			{typeOfModalWindow === 'copyMenu' && (
				<ModalCopyMenu
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseModalWithRefetch}
					onShowError={handleCloseCopyMenuModalWithError}
					customer={customer}
				/>
			)}
		</ModalWrapper>
	);
};
